'use strict';
const { setItemInLocalStorage } = require('./util');

window.addEventListener('load', (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    const referrerID = urlParams.get('referrerID');
    if (referrerID) {
        setItemInLocalStorage('REFERRED_ID', referrerID);
    }
});